import { asyncStorageKeys } from '@inbox-demo-nx/constants';
import { useAuthContext, useScenarioContext } from '@inbox-demo-nx/contexts';
import {
  MainAppMessageTypes,
  ParentMessageTypes,
} from '@inbox-demo-nx/web-demo-constants';
import { useEffect } from 'react';
import { Platform } from 'react-native';

export function useMainAppWindowMessageHandler() {
  const { currentUser } = useAuthContext();
  const scenario = useScenarioContext();

  useEffect(() => {
    if (currentUser && Platform.OS === 'web' && window.parent !== window.self) {
      window.parent.postMessage(
        {
          type: ParentMessageTypes.INIT_SUPPORT_APP,
          userId: currentUser.userId,
          scenarioKey: scenario.key,
        },
        '*'
      );
    }
  }, [currentUser, scenario.key]);

  useEffect(() => {
    if (Platform.OS === 'web') {
      const messageHandler = (event: WindowEventMap['message']) => {
        if (event.data === MainAppMessageTypes.REMOVE_USER_FROM_LOCAL_STORAGE) {
          window.localStorage.removeItem(asyncStorageKeys.savedUser);
          window.parent?.postMessage({ type: ParentMessageTypes.RELOAD }, '*');
        }
      };
      window.addEventListener('message', messageHandler);
      return () => {
        window.removeEventListener('message', messageHandler);
      };
    }
    return;
  }, []);
}

export default useMainAppWindowMessageHandler;
